import { HttpRequestMethod, send } from "../../utils/send";

export class CrudSend<
  Response,
  PostRequest extends object,
  PutRequest extends object,
  T
> {
  constructor(private readonly parse: (response: Response) => T) {
    this.parse = parse;
  }

  getCollection(url?: string): Promise<T[] | null> {
    return url === undefined
      ? Promise.resolve(null)
      : send<Response[]>(url, HttpRequestMethod.GET).then((comments) =>
          comments.map(this.parse)
        );
  }

  post(url: string, body: PostRequest): Promise<T> {
    return send<Response>(url, HttpRequestMethod.POST, body).then((result) =>
      this.parse(result)
    );
  }

  put(url: string, body: PutRequest): Promise<T> {
    return send<Response>(url, HttpRequestMethod.PUT, body).then(this.parse);
  }

  delete(url: string): Promise<boolean> {
    return send<boolean>(url, HttpRequestMethod.DELETE);
  }
}
